export default __webpack_public_path__ + "static/media/0x8d546026012bf75073d8a586f24a5d5ff75b9716.f6c9150d.png";